import { Button } from "@progress/kendo-react-buttons";

export const ApplicationCell = (props) => {
  return ( !props.dataItem.approved && !props.dataItem.denied ? 
    <td>
      <Button
        className="k-button k-success"
        style={{ backgroundColor: '#37b400', color: 'white', width: '100px' }}
        onClick={() => props.approve(props.dataItem)}
        rounded={'large'}
      >
        Approve
      </Button>
      <Button
        className="k-button k-error"
        onClick={() => props.deny(props.dataItem)}
        style={{ backgroundColor: '#f31700', color: 'white', width: '100px' }}
      >
        Deny
      </Button>
    </td> : null
  );
};